import Joi from 'joi';
import type { ExtractValues, SchemaOf } from '../helpers';
import { objectSchemaOf } from '../helpers';

export const eventType = [
  'sendSlackMessage',
  'sendSmsMessage',
  'sendEmailMessage',
  'requestUserInput',
  'userInputResponse',
  'ringBell',
  'requiresIntervention',
  'monitoringStarted',
  'conversationEnd',
  'conversationStart',
  'announcement',
  'invitationCheckIn',
  'selectIntent',
  'conversationFaceUpdated',
  'conversationInteractionMode',
  'conversationRequestInteractionMode',
  'userMessage',
  'hilMessage',
  'botMessage',
  'optionsDisplayed',
  'keyboardDisplayed',
] as const;

export type EventType = ExtractValues<typeof eventType>;

export const source = ['bot', 'hil', 'console', 'user'] as const;
export type Source = ExtractValues<typeof source>;

export interface IEvent {
  type: EventType;
  conversationId: string;
  message: string;
  staffId?: string[];
  eventId: string;
  timestamp: number;
  commandId?: string;
  recordingId?: string;
  source: Source;
  messageId?: string;
}

export const eventSchemaMap: SchemaOf<IEvent> = {
  type: Joi.string()
    .allow(...eventType)
    .required(),
  conversationId: Joi.string().required(),
  staffId: Joi.array().items(Joi.string()).optional(),
  message: Joi.string().required(),
  eventId: Joi.string().required(),
  source: Joi.string()
    .valid(...source)
    .required(),
  timestamp: Joi.number().required(),
  commandId: Joi.string().optional(),
  recordingId: Joi.string().optional(),
  messageId: Joi.string().optional(),
};

export const eventSchema = objectSchemaOf<IEvent>(eventSchemaMap);
